import { useState, useEffect } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const DiagnosticoLinhaDialog = ({ linhaId, onClose }) => {
  const [diag, setDiag] = useState(null);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (!linhaId) return;
    setDiag(null);
    setErro(null);
    axios.get(`${API_URL}/api/automacao/bloqueio/diagnostico-linha/${linhaId}`, { withCredentials: true })
      .then(({ data }) => setDiag(data))
      .catch(e => setErro(e.response?.data?.detail || e.message));
  }, [linhaId]);

  return (
    <Dialog open={!!linhaId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-zinc-950 border-zinc-800 max-w-lg" data-testid="diagnostico-dialog">
        <DialogHeader>
          <DialogTitle className="text-zinc-100">Por que bloqueia (ou não)?</DialogTitle>
        </DialogHeader>
        {!diag && !erro && <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin text-zinc-500" /></div>}
        {erro && <div className="text-sm text-red-400" data-testid="diagnostico-erro">{erro}</div>}
        {diag && (
          <div className="space-y-3">
            <div>
              <div className="font-semibold text-zinc-200" data-testid="diagnostico-cliente">{diag.cliente_nome}</div>
              <div className="text-xs font-mono text-zinc-500">{diag.msisdn}</div>
            </div>
            <ol className="space-y-1.5">
              {diag.passos.map((p, i) => (
                <li key={p.regra} className="flex gap-2 text-sm" data-testid={`diagnostico-passo-${i}`}>
                  {p.ok
                    ? <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />
                    : <XCircle className="w-4 h-4 text-red-400 shrink-0 mt-0.5" />}
                  <div>
                    <div className={p.ok ? 'text-zinc-300' : 'text-red-300 font-medium'}>{p.regra}</div>
                    <div className="text-xs text-zinc-500">{p.detalhe}</div>
                  </div>
                </li>
              ))}
            </ol>
            <div className={`rounded-md border px-3 py-2 text-sm ${diag.seria_bloqueada ? 'border-orange-700 bg-orange-950/30 text-orange-200' : 'border-zinc-700 bg-zinc-900 text-zinc-200'}`}
              data-testid="diagnostico-veredito">
              {diag.veredito}
            </div>
            {diag.resultado_no_ultimo_job && (
              <div className="text-xs text-zinc-400" data-testid="diagnostico-ultimo-job">
                No último bloqueio automático ({diag.ultima_execucao_bloqueio?.data}): {diag.resultado_no_ultimo_job.acao || 'ERRO'}
                {diag.resultado_no_ultimo_job.motivo ? ` — ${diag.resultado_no_ultimo_job.motivo}` : ''}
                {diag.resultado_no_ultimo_job.erro ? ` — ${diag.resultado_no_ultimo_job.erro}` : ''}
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
